<div class="add-success-container">
    <img src="assets/images/add-oem-success.svg" alt="">
    <h2>OEM {{dynamicText}} Sucessfully</h2>
    <div class="footer-btn">
        
        <button class="create-btn" (click)="ok()">OK</button>
    </div>
</div>